<template>
  <router-link :to="{ path: '/works/' + itemSlug }">
    <div 
      v-bind:class="['item-image', itemSlug, {'hover': itemHover}]"
      @mouseenter="itemHover = true"
      @mouseleave="itemHover = false"
      v-bind:style="{backgroundImage: 'linear-gradient(' + itemColor + ',' + itemColor + ')'}"
    >
      <vector :src="require('#/image/logos/logo-' + itemSlug + '.svg')" data-context="work-list" />
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'work-list-item',
  props: ['itemSlug', 'itemColor'],
  data () {
    return {
      itemHover: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .item-image {
    width: 100%;
    height: 340px;
    border-bottom: 1px solid rgba(51, 51, 51, 0.2);
    margin-bottom: 40px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 1));
    background-position: top center;
    background-size: 100% 0%;
    background-repeat: no-repeat;
    transition: all 0.4s cubic-bezier(.37,.36,.23,.99);

    @include device(tablet) {
      height: 300px;
    }

    @include device(mobile) {
      height: 50vw;
    }

    &:hover {
      background-size: 100% 100%;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/WorkListItem.vue